/**
 * @fileoverview Agent definition for selection-reviser-v2.
 *
 * This agent revises a selected piece of text based on user commands
 * and story context, providing inline editing capabilities.
 *
 * @category narrative.prose.revision
 * @type primitive
 */

import type { AppAgentDefinition } from '@/domains/agents/schemas';
import { InputSchema, OutputSchema } from './schema';
import { prompt } from './prompt';

// =============================================================================
// AGENT DEFINITION
// =============================================================================

export const definition: AppAgentDefinition = {
  id: 'selection-reviser-v2',
  kind: 'primitive',
  name: 'Selection Reviser',
  description: 'Revises a selected piece of text based on user commands.',
  category: 'writing',
  defaultPrompt: prompt,
  inputSchema: InputSchema,
  outputSchema: OutputSchema,

  // --- Metadata (Hybrid Architecture) ---
  metadata: {
    status: 'active',
    type: 'primitive',
    addedIn: '2024-06',
    lastUpdated: '2026-01',
    taxonomyPath: 'narrative.prose.revision',
    usedBy: [
      'use-writing-editor.ts',
    ],
    usedInComposites: [],
    relatedAgents: [
      'draft-refiner-v2',
    ],
  },
};
